import $ from "jquery";
import { gsap } from "gsap";
$(function() {

    //footnotes ------------------------------------------
    let _li;
    let _anchor;
    let _marker;
    let _footnote_txt;
    let _content_sup;
    let _href;

    if ($('.footnotes').length > 0) {
        $('.footnotes').each(function(i, o) {
            _li = $(o).find('ol').html();
            $('.footnote_list').append(_li);
            $(o).remove();
        });

        setTimeout(function() {
            $('.bottom_footnote').find('li').each(function(i, o) {
                _anchor = 'footnote-' + i;
                _marker = 'footnote-marker-' + i;
                $(o).find('sup').children('a').attr('href', '#' + _anchor);
                $(o).find('sup').children('a').attr('title', '返回註' + (i + 1));
                $(o).attr('id', _marker);
            });
            $('.content').find('sup').each(function(i, o) {
                _anchor = 'footnote-' + i;
                _marker = 'footnote-marker-' + i;
                _content_sup = $(o).find('a');
                _content_sup.attr('id', _anchor);
                _content_sup.attr('href', '#' + _marker);
                _content_sup.text('[' + (i + 1) + ']');
            });

            $('a[href^="#footnote"]').click(function(e) {
                e.preventDefault();
                _href = $(this).attr('href');
                console.log($(_href).offset().top);
                gsap.to('html, body', { duration: .7, scrollTop: $(_href).offset().top, ease: 'quart.out' });
            });
        }, 1000);

    } else {
        $('.bottom_footnote').hide();
    }


    $('.content').find('sup').hover(function() {
        _anchor = $(this).find('a').attr('href');
        _footnote_txt = $(_anchor).text().replace('^ ', '');
        $(this).append('<div class="sup_footnote">' + _footnote_txt + '</div>');
    }, function() {
        $(this).find('.sup_footnote').remove();
    });
});